"use strict";
// reclaimPricingCalculator consts
Object.defineProperty(exports, "__esModule", { value: true });
exports.SAVED_MEETINGS_FRAC = exports.SAVED_TASK_WORK_FRAC = exports.WEEKS_WORKED_PER_YEAR_PER_PERSON = exports.WEEKS_WORKED_PER_MONTH_PER_PERSON = exports.HOURS_WORKED_PER_WEEK_PER_PERSON = exports.LOWER_BOUNDS = exports.BREAKPOINTS = exports.ADDITIONAL_ANNUAL_DISCOUNT = void 0;
exports.ADDITIONAL_ANNUAL_DISCOUNT = 0.2;
exports.BREAKPOINTS = {
    1: {
        annually: { pro: 6.5, team: 9.5 },
        monthly: { pro: 7.8, team: 11.4 },
    },
    11: {
        annually: { pro: 8.59, team: 12.56 },
        monthly: { pro: 10.31, team: 15.08 },
    },
    51: {
        annually: { pro: 8.4, team: 12.28 },
        monthly: { pro: 10.08, team: 14.74 },
    },
    101: {
        annually: { pro: 7.14, team: 10.44 },
        monthly: { pro: 8.57, team: 12.53 },
    },
    1001: {
        annually: { pro: 6.07, team: 8.87 },
        monthly: { pro: 7.28, team: 10.65 },
    },
};
exports.LOWER_BOUNDS = Object.keys(exports.BREAKPOINTS).map((k) => parseInt(k));
// reclaimROICalculator consts
exports.HOURS_WORKED_PER_WEEK_PER_PERSON = 40;
exports.WEEKS_WORKED_PER_MONTH_PER_PERSON = 4;
exports.WEEKS_WORKED_PER_YEAR_PER_PERSON = 49;
exports.SAVED_TASK_WORK_FRAC = 0.1425;
exports.SAVED_MEETINGS_FRAC = 0.0485;
